import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getUser, getToken, logout } from '@/utils/api';

/**
 * Hook to auto-logout demo users after 45 minutes.
 * Shows a 5-minute warning toast. On expiry, redirects to /admin/login?expired=demo.
 */
const useDemoExpiry = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = getUser();
    if (user?.role !== 'demo') return;

    const token = getToken();
    if (!token) return;

    let expMs;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      expMs = payload.exp * 1000;
    } catch {
      return;
    }

    let warningShown = false;

    const checkExpiry = () => {
      const remaining = expMs - Date.now();
      if (remaining <= 0) {
        logout();
        navigate('/admin/login?expired=demo');
        return;
      }
      if (remaining <= 5 * 60 * 1000 && !warningShown) {
        warningShown = true;
        toast.warning('Your demo session expires in 5 minutes.', {
          duration: Infinity,
          id: 'demo-expiry-warning',
        });
      }
    };

    checkExpiry(); // immediate check
    const timer = setInterval(checkExpiry, 15000); // every 15 s
    return () => clearInterval(timer);
  }, [navigate]);
};

export default useDemoExpiry;
